import React from 'react';
import Footer from '../Footer/Footer';
import ContactHeader from './ContactHeader/ContactHeader';
import ContactPlace from './ContactPlace/ContactPlace';
import krakow from '../../assets/krakow.png';
import wolbrom from '../../assets/wolbrom.png';

const Contact = () => {
    return (
        <>
            <ContactHeader />
            <ContactPlace 
                name="Gabinety Lekarskie i Rehabilitacja"
                address="ul. Władysława Mitkowskiego 4, 30-337 Kraków"
                hours={[
                    ['Poniedziałek', "08:00 - 20:00"],
                    ['Wtorek', "08:00 - 20:00"],
                    ['Środa', "08:00 - 20:00"]
                ]}
                image={krakow}
                alt="Kraków"
            />
            <ContactPlace 
                name="Gabinety Nowa 5"
                address="ul. Nowa 5, 32-340 Wolbrom"
                hours={[
                    ['Czwartek', "08:00 - 20:00"],
                    ['Piątek', "08:00 - 20:00"],
                    ['Sobota', "08:00 - 20:00"]
                ]}
                image={wolbrom}
                alt="Wolbrom"
                lastItem
            />
            <Footer />
        </>
    )
}

export default Contact;